import styled from "styled-components";

export const Alert = styled.div`
  background-color: #ffe6e6;
  color: #8b0000;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;

  &::before {
    content: "⚠️";
    font-size: 1.2rem;
  }
`;
